var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loader text-center"},[_c('img',{attrs:{"src":"/resources/loader.svg","width":"100px"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }